<img *ngIf="hasImage()" [height]="height" [src]="getImage()" [width]="width" mat-list-avatar style="border-radius: 0"/>
<mat-icon *ngIf="!hasImage()" [fontIcon]="'fa-' + getIcon()[1]" [fontSet]="getIcon()[0]" class="hb-mat-mute"
          mat-list-avatar></mat-icon>
